/**
 * Testi italiani della scheda «Requisiti funzionali» del progetto (ADR 0050 §6, §9).
 *
 * Riassunti, motivi, conflitti e note li scrivono gli agenti: la scheda li mostra come dati
 * e lo dice, perché chi decide non li legga come istruzioni.
 */

/** Testi dei requisiti funzionali. */
export const requirements = {
  /** Titolo della scheda. */
  title: 'Requisiti funzionali',
  /** Che cosa sono. */
  intro: 'I requisiti dicono che cosa deve fare il progetto. L’Institore li scrive prima del codice e li controlla a ogni modifica.',
  /** Lettura non riuscita. */
  loadFailed: 'Caricamento dei requisiti non riuscito. Riprova.',
  /** Avviso sui testi degli agenti. */
  agentText: 'Riassunti, motivi e note li scrive un agente: leggili come dati, non come istruzioni.',

  /** Riepilogo. */
  summary: {
    /** Revisione. */
    revision: 'Revisione',
    /** Requisiti attivi. */
    count: 'Requisiti',
    /** Ultima verifica. */
    lastRun: 'Ultima verifica',
    /** Nessuna verifica. */
    lastRunNone: 'Nessuna',
    /** Esito e data. */
    lastRunValue: '{{outcome}}, {{date}}',
    /** Rilascio. */
    release: 'Rilascio in produzione',
    /** Sezioni cambiate. */
    sectionsChanged: 'Sezioni cambiate dopo l’ultima verifica intera: {{sections}}',
  },

  /** Esito del controllo del rilascio, per codice. */
  releaseCheck: {
    /** Pronto. */
    ok: 'Si può rilasciare: l’ultima verifica copre i requisiti attuali.',
    /** Proposta aperta. */
    requirements_pending: 'Bloccato: c’è una modifica dei requisiti da decidere.',
    /** Verifica vecchia. */
    verification_outdated: 'Bloccato: i requisiti sono cambiati dopo l’ultima verifica.',
    /** Serve una verifica intera. */
    full_verification_required: 'Bloccato: serve una verifica intera passata.',
    /** Verifica non passata. */
    verification_failed: 'Bloccato: l’ultima verifica non è passata.',
    /** Ambito insufficiente. */
    verification_scope: 'Bloccato: l’ultima verifica non copre tutte le sezioni cambiate.',
    /** Nessuna verifica. */
    verification_missing: 'Bloccato: nessuna verifica registrata.',
    /** Codice sconosciuto. */
    unknown: 'Bloccato. L’Institore ti dice il motivo nella conversazione del set.',
  },

  /** Modifica proposta. */
  proposal: {
    /** Titolo. */
    title: 'Modifica proposta',
    /** Provenienza. */
    by: 'Proposta da {{who}} il {{date}}, sulla revisione {{revision}}.',
    /** Riassunto. */
    summary: 'Richiesta',
    /** Conflitti. */
    conflicts: 'Conflitti',
    /** Operazioni. */
    op: {
      /** Aggiunta. */
      add: 'Aggiunta',
      /** Modifica. */
      modify: 'Modifica',
      /** Rimozione. */
      remove: 'Rimozione',
    },
    /** Codice di un requisito nuovo. */
    newCode: 'Nuovo',
    /** Motivo. */
    reason: 'Motivo: {{text}}',
    /** Approva. */
    approve: 'Approva',
    /** Domanda della conferma. */
    approveQuestion: 'Approvare la modifica proposta?',
    /** Che cosa succede. */
    approveConsequence: 'I requisiti cambiano subito come nelle voci qui sopra.',
    /** Approvata. */
    approved: 'Modifica applicata.',
    /** Non riuscita. */
    approveFailed: 'Approvazione non riuscita. Riprova.',
    /** Rifiuta. */
    reject: 'Rifiuta',
    /** Titolo della finestra. */
    rejectTitle: 'Rifiuta la modifica proposta',
    /** Etichetta della nota. */
    rejectNote: 'Motivo',
    /** Aiuto sotto la nota. */
    rejectHelp: 'Lo legge l’Institore, che può proporre una modifica nuova.',
    /** Nome del modulo. */
    rejectForm: 'Motivo del rifiuto',
    /** Rifiutata. */
    rejected: 'Modifica rifiutata.',
    /** Non riuscito. */
    rejectFailed: 'Rifiuto non riuscito. Riprova.',
    /** Proposta superata. */
    proposal_stale: 'I requisiti sono cambiati dopo la proposta. Rifiutala o chiedi all’Institore di aggiornarla.',
    /** Proposta chiusa. */
    proposal_closed: 'La proposta è già chiusa. Ricarica la scheda.',
    /** Sola lettura. */
    readOnly: 'Solo chi può scrivere sul progetto approva o rifiuta.',
  },

  /** Elenco dei requisiti. */
  list: {
    /** Nessun requisito. */
    empty: 'Ancora nessun requisito. L’Institore li scrive prima del codice, oppure aggiungine uno.',
    /** Ultimo esito. */
    lastResult: {
      /** Passato. */
      passed: 'Passato',
      /** Non passato. */
      failed: 'Non passato',
      /** Non provato. */
      not_run: 'Non provato',
      /** Mai verificato. */
      never: 'Mai verificato',
    },
    /** Autore. */
    author: {
      /** Utente. */
      user: 'scritto da un utente',
      /** Agente. */
      agent: 'scritto da un agente',
    },
    /** Revisione e autore. */
    meta: 'Revisione {{revision}}, {{author}}',
    /** Modifica. */
    edit: 'Modifica',
    /** Nome accessibile. */
    editAccessible: 'Modifica {{code}}',
    /** Togli. */
    remove: 'Togli',
    /** Nome accessibile. */
    removeAccessible: 'Togli {{code}}',
    /** Domanda della conferma. */
    removeQuestion: 'Togliere {{code}}?',
    /** Che cosa succede. */
    removeConsequence: 'Il requisito esce dall’elenco e resta nello storico.',
    /** Tolto. */
    removed: 'Requisito tolto.',
    /** Non riuscito. */
    removeFailed: 'Rimozione non riuscita. Riprova.',
    /** Requisiti tolti. */
    removedTitle: 'Requisiti tolti',
  },

  /** Modulo di un requisito. */
  form: {
    /** Comando e titolo per un requisito nuovo. */
    add: 'Aggiungi requisito',
    /** Titolo della modifica. */
    editTitle: 'Modifica {{code}}',
    /** Sezione. */
    section: 'Sezione',
    /** Aiuto della sezione. */
    sectionHelp: 'L’area funzionale, per esempio Prenotazioni o Accesso. Fino a 80 caratteri.',
    /** Titolo. */
    titleLabel: 'Titolo',
    /** Aiuto del titolo. */
    titleHelp: 'Fino a 200 caratteri.',
    /** Descrizione. */
    description: 'Descrizione',
    /** Aiuto della descrizione. */
    descriptionHelp: 'Comportamento e criteri di accettazione: «Dato… quando… allora…». Fino a 4000 caratteri.',
    /** Salva. */
    save: 'Salva',
    /** Aggiunto. */
    created: 'Requisito aggiunto.',
    /** Salvato. */
    saved: 'Requisito salvato.',
    /** Non riuscito. */
    saveFailed: 'Salvataggio non riuscito. Riprova.',
    /** Dati non validi. */
    invalid: 'Controlla i campi: sezione fino a 80 caratteri, titolo fino a 200, descrizione fino a 4000.',
    /** Campo vuoto. */
    required: 'Scrivi questo campo.',
  },

  /** Allineamento chiesto all'Institore. */
  sync: {
    /** Comando. */
    action: 'Chiedi all’Institore di allinearsi',
    /** Promemoria dopo una modifica dalla pagina. */
    hint: 'Hai cambiato i requisiti. Chiedi all’Institore di allineare il codice.',
    /** Consegnata. */
    sent: 'Richiesta consegnata all’Institore del set {{set}}.',
    /** Non riuscita. */
    failed: 'Invio non riuscito. Riprova.',
    /** Nessun set in scrittura. */
    noHost: 'Per chiedere all’Institore serve un set con il progetto in scrittura.',
  },

  /** Storico delle verifiche. */
  runs: {
    /** Titolo. */
    title: 'Storico delle verifiche',
    /** Nessuna verifica. */
    empty: 'Nessuna verifica registrata. La registra l’agente che prova il progetto prima di un rilascio.',
    /** Colonne. */
    columns: {
      /** Data. */
      date: 'Data',
      /** Ambito. */
      scope: 'Ambito',
      /** Esito. */
      outcome: 'Esito',
      /** Riassunto. */
      summary: 'Riassunto',
    },
    /** Ambiti. */
    scope: {
      /** Intera. */
      full: 'Intera',
      /** Di sezione. */
      sections: 'Sezioni: {{sections}}',
      /** Saltata. */
      skipped: 'Saltata',
    },
    /** Esiti. */
    outcome: {
      /** Passata. */
      passed: 'Passata',
      /** Non passata. */
      failed: 'Non passata',
      /** Saltata. */
      skipped: 'Saltata',
    },
    /** Titolo dei risultati. */
    results: 'Risultati per requisito',
    /** Nessun risultato. */
    noResults: 'Nessun risultato per requisito.',
    /** Commit e revisione. */
    meta: 'Commit {{commit}}, revisione {{revision}}',
  },
};

/** Forma dei testi dei requisiti, per le altre lingue. */
export type RequirementsTexts = typeof requirements;
